"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "afragola": {
    "eb2b9c43": [{
      "hkey": "2f6c1ed6",
      "slug": "san-marco-saggese-masseria-santa-teresa",
      "name": "San Marco-Saggese-Masseria Santa Teresa",
      "primary": true,
      "skipSearch": false
    }],
    "saggese": [{
      "hkey": "2f6c1ed6",
      "slug": "san-marco-saggese-masseria-santa-teresa",
      "name": "San Marco-Saggese-Masseria Santa Teresa",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;